import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from 'material-ui';
String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

const DyncIcon = ({ icon, style, fontSize }) => {
    //Este workarround se hace porque no normalizamos la base de datos.
    icon = icon.capitalize();
    icon = icon.replace(/(_(\w{1}))/ig, function () { return arguments[2].toUpperCase(); });
    let iconName = icon ? icon.replace(/Icon$/, '') : icon;
    if (!style) {
        style = { color: '#1565C0', verticalAlign: 'bottom', ...style };
    }
    try {
        let resolved = require(`material-ui-icons/${iconName}`).default;
        if (!resolved) {
            //throw Error(`Could not find material-ui-icons/${iconName}`)
            return <Chip label={icon} />;
        } else {
            return React.createElement(resolved, { style: style, fontSize: fontSize });
        }
    } catch (e) {
        return <Chip label={icon} />;
    }
};
DyncIcon.propTypes = {
    icon: PropTypes.string.isRequired,
    style: PropTypes.object,
};
export default (DyncIcon);


// WEBPACK FOOTER //
// ./src/components/Utils/DynIcon.js